import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Eye, EyeOff } from 'lucide-react';

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobile: "",
    annual_income: "",
    marital_status: "",
    education: "",
    city: "",
    gender: "",
    religion: "",
    date_of_birth: "",
    caste: "",
    height: "",
    occupation: "",
    about: "",
    looking_for: "",
    photo: null,
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, photo: e.target.files[0] });
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Email and Mobile Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/; // For Indian numbers
  
    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }
  
    if (!mobileRegex.test(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number starting with 6-9.");
      return;
    }
  
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "date_of_birth") {
        const formattedDate = new Date(formData.date_of_birth).toISOString().split("T")[0];
        data.append("date_of_birth", formattedDate);
      } else {
        data.append(key, formData[key]);
      }
    });
  
    try {
      const response = await axios.post(
        "https://shubhjiwan.co.in/ShubhJiwan_backend11/insert_profile.php",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
  
      console.log("Response:", response.data);
      alert("Profile successfully submitted!");
      localStorage.setItem("profileId", response.data.id);
      navigate("/login");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Submission failed! Please try again.");
    }
  };
  
  return (
    <>
      <Navbar />
     <div className="pt-32 pb-32 bg-gradient-to-br from-blue-100 via-pink-50 to-purple-100">
     <div className="w-1/2 mx-auto bg-white p-8 rounded-lg shadow-2xl relative transition-transform transform hover:scale-105 duration-300">
    <h2 className="text-3xl text-pink-500 font-extrabold mb-6 text-center">Create Your Profile</h2>

    {/* <div className="flex flex-col items-center mb-6">
      <label className="block text-gray-600 font-semibold mb-2">Upload Photo:</label>
      <input type="file" name="photo" accept="image/*" onChange={handleFileChange} className="mb-2" />
      {formData.photo && (
        <div className="w-24 h-24 overflow-hidden rounded-full border-4 border-pink-300">
          <img src={URL.createObjectURL(formData.photo)} alt="Uploaded" className="w-full h-full object-cover" />
        </div>
      )}
    </div> */}

    <div className="flex flex-col items-center mb-6">
  <label className="block text-gray-700 font-semibold mb-3 text-lg">Upload Photo:</label>
  <input
    type="file"
    name="photo"
    accept="image/*"
    onChange={handleFileChange}
    className="mb-3 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
  />
  {formData.photo && (
    <div className="w-28 h-28 overflow-hidden rounded-full border-4 border-blue-400 shadow-md">
      <img
        src={URL.createObjectURL(formData.photo)}
        alt="Uploaded"
        className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
      />
    </div>
  )}
</div>


    <form onSubmit={handleSubmit} className="space-y-6 mb-10">
      <div>
        <label className="block text-gray-600 font-semibold">Name:</label>
        <input type="text" name="name" placeholder="Enter Your Full Name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition" />
      </div>

      <fieldset className="border border-gray-300 p-4 rounded-lg space-y-6">
        <div className="grid sm:grid-cols-2 gap-4 gap-y-6">
          <div>
            <label className="block text-gray-600 font-semibold">Email:</label>
            <input type="email" name="email" placeholder="Enter Your Email Address" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition" />
          </div>

          <div className="relative">
            <label className="block text-gray-600 font-semibold mb-1">Password:</label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your Password"
              className="w-full px-4 py-3 pr-12 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            />
      <button
  type="button"
  onClick={() => setShowPassword(!showPassword)}
  className="absolute top-9 right-2 text-gray-500 hover:text-gray-700 focus:outline-none shadow-none"
>
  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
</button>

          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 gap-y-6">
          <div>
            <label className="block text-gray-600 font-semibold">Mobile:</label>
            <input type="text" name="mobile" placeholder="Enter Your Mobile Number" value={formData.mobile} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition" />
          </div>
          <div>
            <label className="block text-gray-600 font-semibold">Annual Income:</label>
            <select name="annual_income" value={formData.annual_income} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm">
              <option value="" disabled>Select Your Income</option>
              <option value="1.5 Lakh to 4 Lakh">1.5 Lakh to 4 Lakh</option>
              <option value="4 Lakh to 8 Lakh">4 Lakh to 8 Lakh</option>
              <option value="8 Lakh to 10 Lakh">8 Lakh to 10 Lakh</option>
              <option value="above 10 Lakh">above 10 Lakh</option>
            </select>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 gap-y-6">
          <div>
            <label className="block text-gray-600 font-semibold">Marital Status:</label>
            <select name="marital_status" value={formData.marital_status} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm">
              <option value="" disabled>Select Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
            </select>
          </div>
          <div>
            <label className="block text-gray-600 font-semibold">Date of Birth:</label>
            <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition" />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 gap-y-6">
          <div>
            <label className="block text-gray-600 font-semibold">City:</label>
            <input type="text" name="city" placeholder="Enter Your City" value={formData.city} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition" />
          </div>
          <div>
            <label className="block text-gray-600 font-semibold">Gender:</label>
            <select name="gender" value={formData.gender} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm">
              <option value="" disabled>Select Your Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 gap-y-6">
          <div>
            <label className="block text-gray-600 font-semibold">Religion:</label>
            <select name="religion" value={formData.religion} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm">
              <option value="" disabled>Select Your Religion</option>
              <option value="Hindu">Hindu</option>
              <option value="Muslim">Muslim</option>
              <option value="Buddhism">Buddhism</option>
              <option value="Christian">Christian</option>
              <option value="Sikh">Sikh</option>
            </select>
          </div>
          <div>
            <label className="block text-gray-600 font-semibold">Caste:</label>
            <input type="text" name="caste" placeholder="Enter Your Caste" value={formData.caste} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm" />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 gap-y-6">
          <div>
            <label className="block text-gray-600 font-semibold">Height (cm):</label>
            <input type="number" name="height" placeholder="Enter Your Height (in cm)" value={formData.height} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm" />
          </div>
          <div>
            <label className="block text-gray-600 font-semibold">Education:</label>
            <input type="text" name="education" placeholder="Enter Your Education" value={formData.education} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm" />
          </div>
        </div>

        <div>
          <label className="block text-gray-600 font-semibold">Occupation:</label>
          <input type="text" name="occupation" placeholder="Enter Your Occupation" value={formData.occupation} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg shadow-sm" />
        </div>

        <div>
          <label className="block text-gray-600 font-semibold">About Me:</label>
          <textarea
  name="about"
  placeholder="Tell us something about yourself, your interests, or your background..."
  value={formData.about}
  onChange={handleChange}
  required
  style={{ height: '150px' }}
  className="w-full p-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
></textarea>

        </div>

        <div>
          <label className="block text-gray-600 font-semibold">Looking for:</label>
         <textarea
  name="looking_for"
  placeholder="Looking for a caring and respectful partner from a good family background."
  value={formData.looking_for}
  onChange={handleChange}
  required
  style={{ height: '150px' }}
  className="w-full p-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
></textarea>

        </div>
      </fieldset>

      <button
  type="submit"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1px",
    margin: "20px auto 0",
    padding: "12px",
    width: "50%",
    backgroundImage: "linear-gradient(to right, #3B82F6, #8B5CF6)",
    color: "white",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    textAlign: "center",
    border: "none",
    cursor: "pointer",
  }}
  onMouseOver={(e) => {
    e.target.style.backgroundImage =
      "linear-gradient(to right, #8B5CF6, #3B82F6)";
    e.target.style.boxShadow = "0 15px 25px rgba(0, 0, 0, 0.2)";
  }}
  onMouseOut={(e) => {
    e.target.style.backgroundImage =
      "linear-gradient(to right, #3B82F6, #8B5CF6)";
    e.target.style.boxShadow = "0 10px 15px rgba(0, 0, 0, 0.1)";
  }}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="25"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      verticalAlign: "middle",
      transform: "translateY(-1px)",
      transition: "transform 0.3s ease",
      margin: "2px",
      shadow: "none",
      marginLeft: "1px",
    }}
    className="feather feather-send"
  >
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
  Submit
</button>


    </form>

    <p className="text-center text-gray-600 mt-5">
      Already have an account?{" "}
      <button
        onClick={() => navigate("/login")}
        className="text-blue-600 hover:underline hover:text-blue-800 transition"
      >
        Login here
      </button>
    </p>
  </div>
</div>

      <Footer />
    </>
  );
};

export default RegistrationForm;
